import Seo from "@/components/Seo";
import { PageHero, CTABand, Reveal } from "@/components/ui-bits";
import { PROCESS_STEPS } from "@/lib/site";

export default function ExportProcess() {
  return (
    <>
      <Seo
        title="Export Process — From Enquiry to Shipment | Orvella Overseas"
        description="Our eight-step export process: requirement, product selection, quotation, sample approval, order confirmation, quality and packaging, documentation and shipment."
        path="/export-process"
      />

      <PageHero
        eyebrow="Export Process"
        title="From Enquiry to Shipment, in Eight Clear Steps"
        sub="A structured process so international buyers always know what happens next."
      />

      <section className="section-pad">
        <div className="container-x max-w-3xl">
          <ol className="relative space-y-0 border-l-2 border-gold/30 pl-8" data-testid="export-process-timeline">
            {PROCESS_STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.04}>
                <li className="relative pb-10 last:pb-0">
                  <span className="absolute -left-[45px] flex h-9 w-9 items-center justify-center rounded-full border-2 border-gold bg-ivory font-serif text-sm font-semibold text-navy">
                    {s.n}
                  </span>
                  <h2 className="font-serif text-xl font-semibold text-navy">{s.title}</h2>
                  <p className="mt-1.5 text-sm leading-relaxed text-mist">{s.text}</p>
                </li>
              </Reveal>
            ))}
          </ol>
          <Reveal delay={0.2}>
            <p className="mt-10 rounded-lg border border-line bg-sand px-5 py-4 text-xs leading-relaxed text-mist">
              Delivery timelines, shipping lines and commercial terms are confirmed for each order based on the agreed requirement.
            </p>
          </Reveal>
        </div>
      </section>

      <CTABand title="Start with step one — share your requirement" />
    </>
  );
}
